/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, date, DateFormat, entity, enumeration, subentity } from '@gh/core-data';

import { DrawInvoiceStatus, InvoicePhysicalType, InvoiceType } from '../job-draws';
import {
  JobFinancialDrawPaymentDto,
  JobFinancialsDrawDto,
  JobFinancialsDto,
} from './job-financials.dto';

export const JobFinancialsMapper = entity<JobFinancialsDto>({
  invoices: arrayOf(subentity<JobFinancialsDrawDto>({
    accountingDate: date(DateFormat.Date),
    invoiceType: enumeration(InvoicePhysicalType),
    type: enumeration(InvoiceType),
    status: enumeration(DrawInvoiceStatus),
    payments: arrayOf(subentity<JobFinancialDrawPaymentDto>({
      paidDate: date(DateFormat.Date),
    })),
  })),
});
